import React from "react"
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger"
import Tooltip from "react-bootstrap/lib/Tooltip"

import style from "./index.module.sass"

function ServiceCategoryIcon(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { slug } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function getCategoryNameFromSlug(slug) {
    return I18n.t(`service_ordering.${slug}`)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let tooltip = <Tooltip id={slug}>{getCategoryNameFromSlug(slug)}</Tooltip>

  // -------------------------------------

  return (
    <OverlayTrigger placement="bottom" overlay={tooltip}>
      <div className={style.iconContainer}>
        {slug === "spicyspicy" && (
          <div className={`${style.icon} ${style[slug]} m-0`} />
        )}
        <div className={`${style.icon} ${style[slug]}`} />
      </div>
    </OverlayTrigger>
  )
}

export default ServiceCategoryIcon
